module.exports = __webpack_public_path__ + "img/myzus-persicae.b729a20c.jpg";